// Key & Label extractor
// Some 3rd party libraries expect property names code to be key, and display to be label
export const KLExtractor = (codes) => {
	const res = {};
	Object.keys(codes).map((key) => {
		const code = codes[key];
		res[key] = {
			...code,
			key: code.code,
			label: code.display,
			icon: code.code,
		};
		if(code.children) res[key].children = KLExtractor(res[key].children);
	});
	return res;
};